import React from 'react';
import './desktop-nav.css';
import { TABS, ADMIN_TAB, PARENT_TAB, ICONS, openLog, usePendingDrawCount, DrawBadge } from './BottomNav.jsx';

// Desktop-only top tab strip for the investment module (T-008).
//
// Balances / Activity / More were born in the 2026-06-08 mobile redesign as
// bottom-nav destinations and never got desktop entry points — on desktop an
// investor had no way to reach them at all. This strip is the desktop mirror
// of BottomNav: same tabs, icons, and active-tab mapping (imported from
// BottomNav.jsx so the two can't drift), plus the Log action as a regular
// button on the right instead of a center FAB.
//
// Rendered by App.jsx for the investor 'ready' state and the admin
// "acting as investor" state — exactly where BottomNav renders. Hidden at
// the phone breakpoint via CSS (≤480px), the inverse of `.inv-botnav`,
// so exactly one nav is visible at any width. Unlike BottomNav it stays
// visible on form screens (settle-now etc.): those hide the bottom nav only
// because it collides with their sticky action footer, which doesn't exist
// at the top of the page.
export default function DesktopNav({ currentScreen, navigate, adminTab = false }) {
  const active = PARENT_TAB[currentScreen] || 'home';
  const drawCount = usePendingDrawCount();
  const tabs = adminTab ? [...TABS, ADMIN_TAB] : TABS;
  return (
    <nav className="inv-topnav" role="navigation" aria-label="Investment sections">
      <div className="inv-topnav-inner">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            className={'inv-topnav-item' + (active === t.key ? ' active' : '')}
            aria-current={active === t.key ? 'page' : undefined}
            onClick={() => navigate(t.screen)}
          >
            <span className="inv-topnav-ic">{ICONS[t.key]}</span>
            <span>{t.label}</span>
            {t.key === 'home' && <DrawBadge count={drawCount} inline />}
          </button>
        ))}
        <button type="button" className="inv-topnav-log" onClick={openLog}>
          <span className="inv-topnav-ic">{ICONS.plus}</span>
          <span>Log movement</span>
        </button>
      </div>
    </nav>
  );
}
